import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import NewsPage from "../pages/news/page";
import ArticlePage from "../pages/news/article";
import RegisterNgoPage from "../pages/register-ngo/page";
import AdminPage from "../pages/admin/page";
import AdminLoginPage from "../pages/admin/login/page";
import PartnerAccessPage from "../pages/partner-access/page";
import PartnerPortalPage from "../pages/partner-portal/page";
import OrgDetailPage from "../pages/partner-portal/org-detail/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/news", element: <NewsPage /> },
  { path: "/news/:slug", element: <ArticlePage /> },
  { path: "/partner-registration", element: <RegisterNgoPage /> },
  { path: "/partner-access", element: <PartnerAccessPage /> },
  { path: "/partner-portal", element: <PartnerPortalPage /> },
  { path: "/partner-portal/org/:id", element: <OrgDetailPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
